// extracted by mini-css-extract-plugin
export default {"row":"J5dhWeOlatbVm2CNTXl_","button":"wg4JxgXO761KNLtmamy1","list":"he_8EKIWMoOjNq4P3vZ7","form":"a5DVQTuF3HKFuoHdEC9V","error":"O_XQhb3Rgn4hp3VqAyU8"};